import React, { useState } from 'react';

const Settings = () => {
    // For Dismiss Button with Alert
    const [visible, setVisible] = useState(true);

    return (
            <div>
                <h2 className="mb-3">SETTINGS</h2>
            </div>
    );
}

export default Settings;
